/* eslint-disable-next-line */
import { BiCheck, BiX } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import FillPersonIcon from '../Icons/FillPersonIcon';
import Image from 'next/image';

const variantCircle = {
  Done: (
    <div className="flex items-center justify-center bg-[#1EAA0B] border border-[#E9FFE5] rounded-full">
      <BiCheck fill="#fff" size={20} />
    </div>
  ),
  'In Progress': (
    <div className="flex items-center justify-center">
      <div className="w-[22px] h-[22px] bg-[#FFD12B] rounded-full border-[6px] border-[#FFF3C9]"></div>
    </div>
  ),
  Cancelled: (
    <div className="flex items-center justify-center bg-supportiveRed border border-[#F8DCDD] rounded-full">
      <BiX fill="#fff" size={20} />
    </div>
  ),
};

export default function VerticalStepBar({
  steps,
  limit,
  verticalDate,
  compact,
}: {
  steps: any;
  limit?: number;
  verticalDate?: boolean;
  compact?: boolean;
}) {
  const { isMobileScreen } = useSelector((state: IRootState) => state.page);

  return (
    <>
      {steps
        .slice()
        .reverse()
        .map((item, index) => (
          <div key={index} className="flex gap-2">
            <div className="flex flex-col w-fit justify-start items-center">
              {variantCircle[item.status]}
              {index < steps.slice(0, limit || steps.length).length - 1 && (
                <div
                  className={`${
                    item.status === 'Done'
                      ? 'h-full border border-l-[#1EAA0B]'
                      : item.status === 'In Progress'
                        ? 'h-full border border-l-[#FFD12B]'
                        : 'h-full border border-l-reliableBlack30'
                  } ${compact ? 'min-h-[22px]' : item.service?.name || isMobileScreen ? 'min-h-[44px]' : 'min-h-[24px]'}`}
                ></div>
              )}
            </div>
            <div className="w-full mb-2 lg:m-0">
              <div
                className={`flex flex-col gap-1 md:flex-row md:justify-between ${verticalDate ? 'md:flex-col' : 'md:flex-row'}`}
              >
                <p className="text-sm font-bold text-reliableBlack">{item.name}</p>
                {item.additionalNote}
                <p className="text-xs md:text-sm text-reliableBlack60">{item.date}</p>
              </div>

              {item.statusName !== 'ServiceCompleted1' &&
                item.descriptions?.map((desc) => (
                  <p className="text-xs md:text-sm text-reliableBlack60 mt-1">{desc}</p>
                ))}

              {item.service && (
                <div className="flex items-center gap-x-2 lg:gap-x-3 border border-reliableBlack30 rounded px-3 py-2 mt-2 mb-3 w-full md:w-96">
                  {item.service.imageUrl ? (
                    <div className="w-9 h-9 relative rounded-full overflow-hidden mt-1 self-start">
                      <Image
                        src={item.service.imageUrl}
                        alt="Mechanic/Advisor"
                        fill
                        className="object-cover"
                      />
                    </div>
                  ) : (
                    <div className="bg-reliableBlack60 w-9 md:w-11 h-8 md:h-9 rounded-full flex items-center justify-center">
                      <FillPersonIcon size={isMobileScreen ? 18 : 20} />
                    </div>
                  )}
                  <div>
                    <p className="text-sm lg:text-base text-reliableBlack60 font-semibold">
                      {item.service.title}
                    </p>
                    <p className="text-[10px] md:text-xs lg:text-sm text-reliableBlack60">
                      {item.service.name} | {item.service.phoneNumber}
                    </p>
                    {item.service.policeRegNo && item.service.branch && (
                      <p className="text-xs md:text-sm text-reliableBlack60">
                        {item.service.policeRegNo} | {item.service.branch}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
    </>
  );
}
